import axiosInstance from '../../../../services/AxiosInstance';

/** Tamanho do arquivo em texto curto (ex.: "1,4 MB"). */
export const formatFileSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
};

/** Mesmo limite do backend (PdfContractStorage), para avisar antes de enviar. */
export const MAX_CONTRACT_BYTES = 10 * 1024 * 1024;

/** Mensagem de erro se o arquivo escolhido não serve; vazio quando está tudo certo. */
export const validateContractFile = (file) => {
    if (!file) return 'Selecione o arquivo PDF do contrato.';
    if (file.size > MAX_CONTRACT_BYTES) return 'O contrato deve ter no máximo 10 MB.';
    // O backend confere o conteúdo; aqui só evita o envio óbvio de outro tipo de arquivo.
    if (!/\.pdf$/i.test(file.name) && file.type !== 'application/pdf') return 'O contrato deve ser um arquivo PDF.';
    return '';
};

/**
 * Abre um PDF autenticado em nova aba. A rota exige login, então não dá para usar um link
 * simples: baixa como blob com o token do sistema e abre o endereço temporário.
 */
export const openAuthenticatedPdf = async (url) => {
    const response = await axiosInstance.get(url, { responseType: 'blob' });
    // 204 = o registro existe mas o arquivo sumiu do armazenamento.
    if (response.status === 204 || !response.data || response.data.size === 0) {
        throw new Error('O arquivo do contrato não foi encontrado. Envie-o novamente.');
    }
    const objectUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    window.open(objectUrl, '_blank', 'noopener');
    // Libera a memória depois que a aba teve tempo de carregar.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
};
